var _excluded = ["className", "as", "level"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import withWeightModifiers from "../withWeightModifiers/index.js";
import styles from "../../font-scale-categories.css";
var classes = {
  body1: styles.body1,
  body2: styles.body2
};

/**
 * This component also supports the font weight modifier props.
 */
var Body = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    ComponentToRender = _ref.as,
    level = _ref.level,
    props = _objectWithoutProperties(_ref, _excluded);
  var bodyClass = "body".concat(level);
  return /*#__PURE__*/React.createElement(ComponentToRender, _extends({
    ref: ref,
    className: "".concat(className, " ").concat(classes[bodyClass])
  }, props));
});
Body.defaultProps = {
  className: '',
  as: 'div'
};
process.env.NODE_ENV !== "production" ? Body.propTypes = {
  /**
   * Additional classes to apply
   */
  className: PropTypes.string,
  /**
   * Component to render.
   */
  as: PropTypes.elementType,
  /**
   * Body level to render. Must be a number from 1 through 2
   */
  level: PropTypes.oneOf([1, 2]).isRequired
} : void 0;
export default withWeightModifiers(Body);